import { CsValidation } from "../shared/csValidationForm";
import { Button, Icon, TextField } from "@shopify/polaris";
import CsI18n from "../shared/csI18n/";
import { MinusMinor, PlusMinor } from "@shopify/polaris-icons";
import React from "react";

const TableHelper = {
  cellLabel: (label, index) => {
    return index === 0 ? label : '';
  },

  dataTableRows: (name, data, handleArrayChange, handleArrayAdded, handleArrayRemoved) => {
    let rows = [];

    data.map((item, itemIndex) => {
      let row = [];

      // Append cell to row
      Object.keys(item).map(cellKey =>
        row.push(
          <CsValidation>
            <TextField label={''} value={item[cellKey]} onChange={handleArrayChange(name, itemIndex, cellKey)} />
            <CsValidation.Item rule="required" title={CsI18n.t("This field is required.")} />
          </CsValidation>
        )
      );

      // Append tail action to row
      row.push(
        itemIndex === 0 ?
          <Button icon={<Icon source={PlusMinor} color="skyDark" />}
                  onClick={handleArrayAdded(name)}
                  outline><CsI18n>Add</CsI18n></Button> :
          <Button icon={<Icon source={MinusMinor} color="skyDark" />}
                  onClick={handleArrayRemoved(name, itemIndex)}
                  outline><CsI18n>Remove</CsI18n></Button>
      );

      return rows.push(row);
    });

    return rows;
  },

  removeRow: (currentData, removeIndex) => {
    let dataModify = [...currentData];  // Copy by value
    dataModify.splice(removeIndex, 1);
    return dataModify;
  },

  onChange: (changedValue, currentData, index, cellName) => {
    return currentData.map((item, itemIndex) => {
      let itemModify = Object.assign({}, item);
      if (index === itemIndex) {
        itemModify[cellName] = changedValue;
      }
      return itemModify;
    });
  }
}

export default TableHelper;